import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UiHelperService } from '@core/services/core/ui-helper.service';
import { Language } from '@models/language';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-language',
  templateUrl: './select-language.component.html',
  styleUrls: ['./select-language.component.scss']
})
export class SelectLanguageComponent implements OnChanges {

  @Input() supportedLanguages: Language[];
  @Input() selectedLanguageId: string;
  @Input() dialogMessage: string;
  @Output() selectedLanguageChange = new EventEmitter<Language>();

  selectedLanguage: Language;

  constructor(
    private trans: TranslateService,
    private ui: UiHelperService
  ) { }

  ngOnChanges() {
    this.selectedLanguage = this.supportedLanguages.find(lng => lng.id === this.selectedLanguageId);
  }

  onOpenLanguageSelector() {
    this.ui.presentCustomRadioDialog(
      this.dialogMessage,
      this.translatedSupportedLanguages(),
      id => {
        this.setLanguage(id);
      }
    );
  }

  private async setLanguage(id: string) {
    if (id) {
      this.selectedLanguage = this.supportedLanguages.find(lng => lng.id === id);
      this.selectedLanguageChange.emit(this.selectedLanguage);
    }
  }

  private translatedSupportedLanguages() {
    return this.supportedLanguages.map(language => {
      return {
        ...language,
        label: this.trans.instant(language?.label)
      };
    });
  }

}
